import * as Control$dBind from "../Control.Bind/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Record from "../Record/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const modify = v => x => v._2(x);
const switchRecordNil = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {switchRecord: v => v1 => to({})};
};
const switchRecord = dict => dict.switchRecord;
const switchRecordI = dictSwitchRecord => () => ({switch: dictSwitchRecord.switchRecord(Type$dProxy.Proxy)});
const switchEvent = {switch: Specular$dFRP$dBase.switch};
const switchEffect = {
  switch: x => {
    const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(x);
    return () => {
      const $1 = $0();
      return $1();
    };
  }
};
const switchDynamic = {switch: m => Specular$dFRP$dBase.bindDynamic.bind(m)(Control$dBind.identity)};
const $$switch = dict => dict.switch;
const switchFunction = dictSwitch => ({switch: f => x => dictSwitch.switch(Specular$dFRP$dBase.functorDynamic.map(v => v(x))(f))});
const switch2 = /* #__PURE__ */ (() => switchFunction(switchEffect).switch)();
const switchRecordCons = dictIsSymbol => () => () => dictSwitch => dictSwitchRecord => () => (
  {
    switchRecord: v => dyn => Record$dUnsafe.unsafeSet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(dictSwitch.switch(Specular$dFRP$dBase.functorDynamic.map(Record.get(dictIsSymbol)()(Type$dProxy.Proxy))(dyn)))(dictSwitchRecord.switchRecord(Type$dProxy.Proxy)(dyn))
  }
);
const switchRef = {
  switch: dyn => Specular$dRef.$Ref(
    Specular$dFRP$dBase.bindDynamic.bind(Specular$dFRP$dBase.functorDynamic.map(Specular$dRef.value)(dyn))(Control$dBind.identity),
    switch2(Specular$dFRP$dBase.functorDynamic.map(modify)(dyn))
  )
};
const dynamicSwitch = dictSwitch => {
  const switch3 = dictSwitch.switch;
  return dictMonadReplace => {
    const dynamic = Specular$dFRP$dReplaceable.dynamic(dictMonadReplace);
    return dictMonadFRP => {
      const $0 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map(switch3);
      const $1 = dynamic(dictMonadFRP);
      return x => $0($1(x));
    };
  };
};
export {
  dynamicSwitch,
  modify,
  $$switch as switch,
  switch2,
  switchDynamic,
  switchEffect,
  switchEvent,
  switchFunction,
  switchRecord,
  switchRecordCons,
  switchRecordI,
  switchRecordNil,
  switchRef
};
